import React, { useState, useEffect } from 'react';
import { DataGridPremium, GridColDef, GridValueFormatterParams, GridSelectionModel  } from '@mui/x-data-grid-premium';
import { Dialog, DialogActions, DialogContent,DialogTitle,TextField, DialogContentText,Select, IconButton, Grid, Button, Box, MenuItem, FormControl, InputLabel, FormControlLabel, Checkbox } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EmailEditModal from './EmailReviewForm'; // Import your Email Edit Modal component

import { Edit, Delete } from '@material-ui/icons';
import dayjs from 'dayjs';
import axios from 'axios';
import styles from './EventMassEmailMaintenanceTable.module.css';
import {useParams} from "react-router";
import {useAutoEvent} from "../../queries/useAutoEvent";
interface Params {
  eventid: string
}

interface EmailRow {
  id: number;
  emailName: string;
  emailType: string;
  askGuestToRegister: boolean;
  readOnly: boolean;
  active: boolean;
  selectedCount: number;
  lastSent: string | null;
  data: any[];
}
// 
const MassEmailMaintenanceTable = () => {
  const [emails, setEmails] = useState<EmailRow[]>([]);
  const [dialogObj, setDialogObj] = useState({ msg: '', id: 0 });
  const [reload, setReload] = useState(0);
  const [selectedRows, setSelectedRows] = useState<GridSelectionModel>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [emailFormData, setEmailFormData] = useState<EmailRow | null>(null);
  const [emailType, setEmailType] = useState('');
  const [askForAuctionSnap, setAskForAuctionSnap] = useState(false);
  const [isEmailEditModalOpen, setIsEmailEditModalOpen] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState<EmailRow | null>();
  const [emailTypes, setEmailTypes] = useState([]); // State to store email types for dropdown
  const { eventid } = useParams<Params>()
  useAutoEvent(eventid)
  useEffect(() => {
    // Function to fetch data from the API
    const fetchData = async () => {
      try {
        const response = await axios.post('https://testapi.auctionsnap.com:8443/evtmassemail', { eventid: eventid });
        const data = response.data.jsonString ? JSON.parse(response.data.jsonString) : null;

        if (data && data.status === "success") {
          // Update the emails state with massemaillist
          setEmails(data.massemaillist.map(item => ({
            id: item.massemailid,
            emailName: item.massemailname,
            emailType: item.massemailtypedescription,
            askGuestToRegister: item.massemailaskguesttoregister,
            readOnly: item.readonly,
            active: item.active,
            selectedCount: item.massemailselectedcount,
            lastSent: item.massemaillastsent || null,
          })));

          // Update email types for the dropdown
          setEmailTypes(data.typelist.map(type => ({
            id: type.typeid,
            description: type.typedescription
          })));
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [reload]);


  const handleOpenEmailEditModal = (email: EmailRow | null) => {
    setSelectedEmail(email); // null for new email, or pass the selected email for editing
    setIsEmailEditModalOpen(true);
  };

  const handleCloseEmailEditModal = () => {
    setIsEmailEditModalOpen(false);
    setSelectedEmail(null);
  };
  // Fetch data (replace with your API call)
  useEffect(() => {
    // Fetch emails and setEmails...
  }, [reload]);

  const handleEdit = (id: number) => {
    // Edit logic...
   // setSelectedEmail(defaultEmailRow); // null for new email, or pass the selected email for editing
    setIsEmailEditModalOpen(true);
  };



  const handleEmailTypeChange = (event) => {
    setEmailType(event.target.value);
    console.log(emailType)
  };

  const handleAuctionSnapChange = (event) => {
    setAskForAuctionSnap(event.target.checked);
  };
  const handleOpenModal = () => {
    setIsModalOpen(true);

    setEmailFormData(null); // Reset form data for new entry
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSaveEmail = () => {
    // Logic to save the new or edited email
    handleCloseModal();
  };
  const columns: GridColDef[] = [
    
    {
      field: 'emailName',
      headerName: 'Email Name',
      type: 'string',
      width: 200,
    },
    {
      field: 'emailType',
      headerName: 'Type',
      type: 'string',
      width: 150,
    },
    {
      field: 'selectedCount',
      headerName: 'Selected Count',
      type: 'number',
      width: 150,
    },
    
    {
      field: 'totalSent',
      headerName: 'Total Sent',
      type: 'number',
      width: 100,
    },
    {
      field: 'askGuestToRegister',
      headerName: 'Ask Guest to Register',
      type: 'boolean',
      width: 200,
    },
   
    {
      field: 'lastSent',
      headerName: 'Last Sent',
      type: 'dateTime',
      width: 150,
      valueFormatter: (params: GridValueFormatterParams) => params.value ? dayjs(params.value as string).format('MM-DD-YYYY') : '',
    },
    {
      field: 'edit',
      headerName: 'Edit',
      renderCell: (params) => (
        <IconButton onClick={() => handleEdit(params.row.id)}>
          <Edit />
        </IconButton>
      ),
      width: 100
    },
  ];
  
  return (
    <div className={styles.root}>
      <h1>Mass Email Maintenance</h1>

      {/* Add Button */}
      <Box mb={2}>
        <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleOpenModal}>
          Add Email
        </Button>
      </Box>

      <DataGridPremium
        autoHeight
        rows={emails}
        columns={columns}
      />

   

      {/* Popup Modal for Adding/Editing Email */}
      <Dialog open={isModalOpen} onClose={handleCloseModal} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{emailFormData ? 'Edit Email' : 'Add New Email'}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="emailName"
            label="Mailing Name"
            type="text"
            fullWidth
            value={emailFormData?.emailName || ''}
            onChange={(e) => setEmailFormData({ ...emailFormData, emailName: e.target.value })}
          />
                    {/* Dropdown for Email Types */}
                    <FormControl fullWidth margin="dense">
      <InputLabel id="email-type-label">Type of Email</InputLabel>
      <Select
        labelId="email-type-label"
        id="email-type-select"
        value={emailType}
        onChange={handleEmailTypeChange}
        label="Type of Email"
      >
        {emailTypes.map((type) => (
          <MenuItem key={type.id} value={type.id}>{type.description}</MenuItem>
          ))}
      </Select>
    </FormControl>

          {/* Checkbox for Auction Snap Registration */}
          {emailType == '26' && (

          <FormControlLabel
            control={
              <Checkbox
                checked={askForAuctionSnap}
                onChange={handleAuctionSnapChange}
                name="askForAuctionSnap"
              />
            }
            label="Ask Guest if they want to be registered for Auction Snap"
          />)}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSaveEmail} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <EmailEditModal
        isOpen={isEmailEditModalOpen}
        handleClose={handleCloseEmailEditModal}
        emailData={selectedEmail} // Pass the selected email data for editing
      />
    </div>
  
  );
};

export default MassEmailMaintenanceTable;
